
import vedant from "../images/himanshu.jpeg";

export const recommendationsData = [
  
  {
    name: "Himanshu Pednekar",
    designation: "SDE @Morgan Stanley",
    quote:
      "Harshwardhan is a hardworking guy, he has proved himself to be an important asset when it came to building real world applications by helping with the knowledge he has gained on working on his skill, he will give his best in any team he works with, may it be tech or non tech, he gets the work done.",
    image: vedant,
    linkedin: "https://www.linkedin.com/in/himanshu-pednekar/",
  },
];
